// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Admin-Offices-ModalCredentials-___ModalCredentials-module__form {
  margin-top: 25px !important;
  margin-bottom: 20px !important;
  background-color: #eeeeee;
  border-radius: 5px;
  padding: 20px 0 !important;
}

.app-pages-Admin-Offices-ModalCredentials-___ModalCredentials-module__inputs {
  margin-left: 40px;
}

.app-pages-Admin-Offices-ModalCredentials-___ModalCredentials-module__input {
  font-size: 20px;
  min-width: 400px;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Admin/Offices/ModalCredentials/ModalCredentials.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".form {\n  margin-top: 25px !important;\n  margin-bottom: 20px !important;\n  background-color: #eeeeee;\n  border-radius: 5px;\n  padding: 20px 0 !important;\n}\n\n.inputs {\n  margin-left: 40px;\n}\n\n.input {\n  font-size: 20px;\n  min-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `app-pages-Admin-Offices-ModalCredentials-___ModalCredentials-module__form`,
	"inputs": `app-pages-Admin-Offices-ModalCredentials-___ModalCredentials-module__inputs`,
	"input": `app-pages-Admin-Offices-ModalCredentials-___ModalCredentials-module__input`
};
export default ___CSS_LOADER_EXPORT___;
